export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13462.b17d0a83.jpg";